// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__IXOT6"};